import Messaging from '@/src/helpers/messaging';
import VideoAudioChat from '@/src/helpers/videoAudioChat';
import Analytics from '@/src/plugins/analytics';
import { createApp } from '@/src/renderer/app';

import { type App as VueApp } from 'vue';
import { PageContext } from '../composables/usePageContext';

type ClientLibs = {
  Analytics: typeof Analytics.install;
  Messaging: typeof Messaging;
  VideoAudioChat: typeof VideoAudioChat;
};

let lastPath: string | null = null;
let lastApp: VueApp | null = null;

export async function onRenderClient(pageContext: PageContext): Promise<void> {
  const clientLibs: ClientLibs = {
    Analytics: Analytics.install,
    Messaging,
    VideoAudioChat,
  };

  const { app } = await createApp(pageContext, clientLibs);

  // Initialize Sentry with the Vue app instance
  // SentryPlugin.install(app);

  if (lastApp && lastPath !== pageContext.urlPathname) {
    lastApp.unmount();
    lastApp = null;
    lastPath = pageContext.urlPathname;
  }

  if (!lastApp && app) {
    app.mount('#app');
    lastApp = app;
  }
}
